import { z } from "zod";

export const bootsrapResolver = z.object({
	version: z.string(),
	staticVersion: z.string(),
	loggedIn: z.string(),
	site: z.string(),
	language: z.string(),
	locale: z.string(),
	languages: z.array(
		z.object({
			code: z.string(),
			label: z.string()
		})
	),
	siteconfig: z.record(z.any()),
	country: z.string(),
	country2: z.string(),
	regionIsoCode: z.string().nullable(),
	countryLangs: z.array(z.string()),
	countryRestricted: z.boolean(),
	env: z.string(),
	mobile: z.boolean(),
	footerText: z.record(z.string()),
	sessionName: z.string(),
	hideEmailExistance: z.boolean().nullable().optional(),
	useRecaptcha: z.boolean(),
	smsEnabled: z.boolean(),
	gameFileTime: z.object({
		gameList: z.string(),
		gzFiles: z.string()
	}),
	countryAgeBan: z.record(z.number()).or(z.string()),
	menu: z.array(
		z.object({
			menuId: z.string(),
			menuName: z.record(z.string())
		})
	),
	user: z.record(z.any()).nullable().or(z.boolean()),
	banners: z.array(
		z.object({
			html: z.string(),
			platform: z.array(z.string()),
			tags: z.array(z.string()),
			visibility: z.array(z.string()),
			NumberInGroup: z.number()
		})
	),
	socialNetworks: z.array(
		z.object({
			id: z.string(),
			name: z.string()
		})
	),
	seo: z.record(z.any()).or(z.any())
});

export type BootsrapModel = z.infer<typeof bootsrapResolver>;

export const sendSupportRequestParamsResolver = z.object({
	senderName: z.string(),
	senderEmail: z.string().email(),
	subject: z.string(),
	message: z.string()
});

export type SendSupportRequestParamsModel = z.infer<typeof sendSupportRequestParamsResolver>;
